export const SET_DOCUMENTS = 'SET_DOCUMENTS';
export const CLEAR_DOCUMENTS = 'CLEAR_DOCUMENTS';

export const clearDocuments = {
  type: CLEAR_DOCUMENTS,
}

export const setDocuments = (data) => {
  return {
    type: SET_DOCUMENTS,
    payload: data,
  }
}